import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { Leaderboard } from '../features/pin/Leaderboard';

export const Route = createFileRoute('/classement')({
  component: () => (
    <RequireRole allow={['vendeur', 'superviseur', 'manager']}>
      <Leaderboard />
    </RequireRole>
  ),
});
